import { secure_env } from "@environments/env-secure";

const AccessControlList = {
  gitAccessDetails: secure_env.SCC_GIT_ACCESS_TOKEN,
  gitProjId: secure_env.SCC_GIT_PROJECT_ID
}

const constantVariables = {
  dev: {
    ...AccessControlList,
    APIEndpoint: "https://api.coursecollection.scc.dev.idp.com",
    APIKey: secure_env.SCC_BFF_API_KEY,
    // assetsEndpoint: 'http://localhost:4200',
    assetsEndpoint: 'https://assets.scc.dev.idp.com',
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_tS5cGAMc5",
    userPoolWebClientId: "499tgalehsqilm5c8ehegmqqup",
    domain: "idp-staff-v1-dev.auth.ap-southeast-1.amazoncognito.com",
    // redirectSignIn: 'http://localhost:4200',
    // redirectSignOut: 'http://localhost:4200',
    redirectSignIn: 'https://scc.dev.idp.com',
    redirectSignOut: 'https://scc.dev.idp.com',
    passPhrase: secure_env.SCC_PASS_PHRASE_DEV,
    name: 'dev',
    environment: 'development'
  },
  stg: {
    ...AccessControlList,
    APIEndpoint: "https://api.coursecollection.scc.stg.idp.com",
    APIKey: secure_env.SCC_BFF_API_KEY,
    assetsEndpoint: 'https://assets.scc.stg.idp.com',
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_CFz5LZxbv",
    userPoolWebClientId: "109qm9e047uheiu8cjansfjnr6",
    domain: "idp-staff-v1-stg.auth.ap-southeast-1.amazoncognito.com",
    redirectSignIn: 'https://scc.stg.idp.com',
    redirectSignOut: 'https://scc.stg.idp.com',
    passPhrase: secure_env.SCC_PASS_PHRASE_STG,
    name: 'stage',
    environment: 'staging'
  },
  uat: {
    ...AccessControlList,
    APIEndpoint: "https://api.coursecollection.scc.uat.idp.com",
    APIKey: secure_env.SCC_BFF_API_KEY,
    assetsEndpoint: 'https://assets.scc.uat.idp.com',
    region: "ap-southeast-1",
    userPoolId: "",
    userPoolWebClientId: "",
    domain: "idp-staff-v1-uat.auth.ap-southeast-1.amazoncognito.com",
    redirectSignIn: 'https://scc.uat.idp.com',
    redirectSignOut: 'https://scc.uat.idp.com',
    passPhrase: secure_env.SCC_PASS_PHRASE_UAT,
    name: 'uat',
    environment: 'uat'
  },
  prd: {
    ...AccessControlList,
    APIEndpoint: "https://api.coursecollection.scc.idp.com",
    APIKey: secure_env.SCC_BFF_API_KEY,
    assetsEndpoint: 'https://assets.scc.idp.com',
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_jdXPguW3t",
    userPoolWebClientId: "1alq7rubc5559tqtob4u7v1rbe",
    domain: "idp-staff-v1-prd.auth.ap-southeast-1.amazoncognito.com",
    redirectSignIn: 'https://scc.idp.com',
    redirectSignOut: 'https://scc.idp.com',
    passPhrase: secure_env.SCC_PASS_PHRASE_PRD,
    name: null,
    environment: 'production'
  }
};

export const constant = constantVariables;
